<template>
    <footer class="footer" ref='footer'>
        <p v-if="!view">
            By answering the questions, you agree to the data collection.
            <br />
            © 2020. ABCMobile OÜ
            <br />
            Harju maakond, Tallinn, Peterburi tee 71-318, 11415, Estonia.
            <br />
            Email: support@abcmobile.com
            <br />
            See our <a href="./terms.php" target="_blank">Terms and Conditions</a> and <a href="./privacy.php" target="_blank">Privacy Policy</a>
            <br />
            Affiliate: mobstra.com
        </p>
        <p v-else>
            Calls cost £3/call +  £3/min, calls recorded, for entertainment only 18+. 
            <br />
            Customer care support@abcmobile.com
            <br />
            © 2020. ABCMobile OÜ
            <br />
            Harju maakond, Tallinn, Peterburi tee 71-318, 11415, Estonia.
            <br />
            See our <a href="./terms.php" target="_blank">Terms and Conditions</a> and <a href="./privacy.php" target="_blank">Privacy Policy</a>
            <br />
            Affiliate: mobstra.com
        </p>
    </footer>
</template>

<style lang="scss" scoped>
    p {
        margin: 0 auto;
        max-width: 400px;
    }

    .footer {
        font-size: 11px;
        position: relative;
        top: -25px;
        text-align: center;
        width: 100%;
        padding: 0 15px;
        background: url(../assets/img/bg-sign.png), #ede6de;
        background-size: contain;

        p {
            color: #7B8B9E;
            max-width: 400px;
            margin: 0 auto;
        }
        a {
            text-decoration: none;
            color: #7B8B9E;
        }

        @media (max-width: 320px) {
            min-width: 283px;
        }
    }
</style>

<script>
    export default {
        props: ['view'],
        computed: {
            call() {
                return this.view
            }
        }
    }
</script>